module.exports = __webpack_public_path__ + "img/show_tc_text_6.581b4a1c.png";